import * as React from 'react';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { ApplePayExpressCheckoutButtonContainer, GooglePayExpressCheckoutButtonContainer, PaypalExpressButton } from '@grandvisionhq/payments';

const ExpressActionContainer = ({ hasSubscription , isOrderInProgress , setIsOrderInProgress , onClickHandler  })=>{
    const [{ cartId , cartHash  }] = useCartStorage();
    if (!cartId) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", {
        className: "express-action__payment-methods"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(ApplePayExpressCheckoutButtonContainer, {
        cartId: cartId,
        onClickHandler: onClickHandler
    })), /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(GooglePayExpressCheckoutButtonContainer, {
        cartId: cartId,
        onClickHandler: onClickHandler
    })), !hasSubscription && cartHash && /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(PaypalExpressButton, {
        setIsOrderInProgress: setIsOrderInProgress,
        cartId: cartId,
        cartHash: cartHash,
        isOrderInProgress: isOrderInProgress,
        onClickHandler: onClickHandler
    })));
};

export { ExpressActionContainer };
//# sourceMappingURL=ExpressActionContainer.js.map
